// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * types of resources
 */
export type MediaTypeOutput = (typeof MediaTypeOutput)[keyof typeof MediaTypeOutput];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MediaTypeOutput = {
  document: 'document',
  video: 'video',
  presentation: 'presentation',
  image: 'image',
  audio: 'audio',
  jupyter_notebook: 'jupyter_notebook',
  spreadsheet: 'spreadsheet',
  link: 'link',
} as const;
